import { render, staticRenderFns } from "./question-resource.vue?vue&type=template&id=3e4467fd&scoped=true"
import script from "./question-resource.vue?vue&type=script&lang=js"
export * from "./question-resource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4467fd",
  null
  
)

export default component.exports